var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title-header-text"},[_vm._v(" "+_vm._s(_vm.title)+_vm._s(_vm.detail == "" ? "" : ` / ${_vm.detail}`)+" ")]),_c('hr',{staticClass:"title-header-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }